// extracted by mini-css-extract-plugin
export default {"productList":"ProductSaleCell_productList__03Hnz","refundedProduct":"ProductSaleCell_refundedProduct__3Zo+M"};